import React, { Fragment } from 'react';
import { Card, Row, Col, Table } from 'react-bootstrap';
import Historial from './historial';


const Seguimiento = ({ proceso, idCaso, idOrgCaso, tipoGestion }) => {
    const implicados = [
        {
            idImplicado: '1',
            nombreImplicado: 'asdasdasdsad',
            patenteImplicado: 'asdasdsadasd'
        },
        {
            idImplicado: '1',
            nombreImplicado: 'asdasdasdsad',
            patenteImplicado: 'asdasdsadasd'
        },
    ]

    return (
        <Fragment>
            <hr style={{ borderTop: '3px solid #04005D' }}></hr>
            <Card>
                <Card.Header className="customHeader">
                    PROCESO JUDICIAL <span>{proceso?.tribunal} - Nro. Causa/Rol {proceso?.rolCausa}</span>
                </Card.Header>

                <Card.Body>
                    <Row>
                        <Col md='4'>
                            <h6 style={{ color: '#3a3a8d' }}>Implicado(s)</h6>

                            <div style={{ overflowX: 'auto', height: '120px' }}>
                                <Table striped>
                                    <tbody>
                                        {proceso?.implicados.map((implicado, index) => (
                                            <tr key={index}>
                                                <td>{implicado?.idImplicado}</td>
                                                <td>{implicado?.nombreImplicado}</td>
                                                <td>{implicado?.patenteImplicado}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                                {proceso?.implicados?.length === 0 &&
                                    <span style={{ display: 'inherit', textAlign: 'center' }}>No hay registros encontrados.</span>
                                }
                            </div>
                        </Col>
                    </Row>
                </Card.Body>

                <Historial
                    proceso={proceso}
                    idCaso={idCaso}
                    codTipoGestion={tipoGestion}
                    idOrgCaso={idOrgCaso}
                />
            </Card>
        </Fragment>
    )
}

export default Seguimiento;